import { JsonConverter, JsonElementType, JsonObject, JsonProperty } from "ta-json";

import type { MapStringTo, Nullable } from "../base-types";
import { DateConverter } from "../converters/date-converter";
import { RelationMapResourceConverter } from "../converters/relation-map-resource-converter";
import CultureInfo from "../culture-info";
import Link from "../link";
import { EntityPath } from "./entity-path";
import { RelationMapResource } from "./relation-map-resource";
import Resource from "./resource";

@JsonObject()
export class EntityResource extends Resource {
    @JsonProperty("id")
    id: number;

    @JsonProperty("identifier")
    identifier: Nullable<string>;

    @JsonProperty("entitydefinition")
    entityDefinition: Link;

    @JsonProperty("cultures")
    @JsonElementType(String)
    cultures: Array<CultureInfo>;

    @JsonProperty("relations")
    @JsonConverter(RelationMapResourceConverter)
    relations: RelationMapResource;

    @JsonProperty("properties")
    properties: MapStringTo<unknown>;

    @JsonProperty("renditions")
    renditions: MapStringTo<unknown>;

    @JsonProperty("related_paths")
    relatedPaths?: MapStringTo<unknown>;

    @JsonProperty("locked_by")
    lockedBy?: Link;

    @JsonProperty("locked_on")
    @JsonConverter(DateConverter)
    lockedOn?: Nullable<Date>;

    @JsonProperty("is_root_taxonomy_item")
    isRootTaxonomyItem: boolean;

    @JsonProperty("is_path_root")
    isPathRoot: boolean;

    @JsonProperty("inherits_security")
    inheritsSecurity: boolean;

    @JsonProperty("is_system_owned")
    isSystemOwned: boolean;

    @JsonProperty("version")
    version: number;

    @JsonProperty("created_on")
    @JsonConverter(DateConverter)
    createdOn?: Date;

    @JsonProperty("modified_on")
    @JsonConverter(DateConverter)
    modifiedOn?: Date;

    @JsonProperty("created_by")
    createdBy?: Link;

    @JsonProperty("modified_by")
    modifiedBy?: Link;

    @JsonProperty("requested_permissions")
    requestedPermissions?: MapStringTo<boolean>;

    @JsonProperty("copy")
    copy?: Link;

    @JsonProperty("permissions")
    permissions?: Link;

    @JsonProperty("lifecycle")
    lifeCycle?: Link;

    @JsonProperty("saved_selections")
    savedSelections?: Link;

    @JsonProperty("roles")
    roles?: Link;

    @JsonProperty("annotations")
    annotations?: Link;

    @JsonProperty("full")
    full?: Link;

    @JsonProperty("is_current_user_default")
    isCurrentUserDefault?: boolean;

    @JsonProperty("language_supported_ootb")
    languageSupportedOotb?: boolean;

    @JsonProperty("HasPublicLink")
    hasPublicLink?: boolean;

    @JsonProperty("annotationCount")
    annotationCount?: number;

    @JsonProperty("masterFileModifiedOn")
    masterFileModifiedOn?: Date;

    @JsonProperty("saved_selection_page_name")
    savedSelectionPageName?: string;

    @JsonProperty("gateway_links")
    gatewayLinks?: Record<string, Link>;

    @JsonProperty("public_link")
    publicLink?: string;

    @JsonProperty("public_collection_link")
    publicCollectionLink?: string;

    @JsonProperty("is_enabled")
    isEnabled?: boolean;

    @JsonProperty("modules")
    @JsonElementType(String)
    modules?: Array<string>;

    @JsonProperty("path")
    @JsonElementType(EntityPath)
    path?: Array<EntityPath>;

    @JsonProperty("CombinedPublishStatus")
    combinedPublishStatus?: string;

    @JsonProperty("CombinedPublishStatusDetails")
    combinedPublishStatusDetails?: string;

    @JsonProperty("external_data_identifier")
    externalDataIdentifier?: string;

    // ExtensionData
    [key: string]: unknown;

    constructor(init?: Partial<EntityResource>) {
        super();
        Object.assign(this, init);
    }
}
